import { z } from "zod";

import { type AddressFields, getAddressIssues, normalizeCountry } from "~/shared/utils/address-normalization";

/** Completeness for a reusable postal block, not address-existence verification. */
export const hasShippingLocationDocumentAddress = (address: AddressFields & { street1?: string | null; city?: string | null }): boolean => {
  if (!address.street1?.trim() || !address.city?.trim() || !address.country?.trim() || getAddressIssues(address).length > 0) {
    return false;
  }
  const country = normalizeCountry(address.country);
  return !["US", "CA", "MX"].includes(country ?? "") || Boolean(address.state?.trim() && address.zip?.trim());
};

export const OrderDocumentSourceTypeSchema = z.enum(["order", "purchaseOrder"]);
export type OrderDocumentSourceType = z.infer<typeof OrderDocumentSourceTypeSchema>;

/** Source choices affect this issued document only, never the operational address. */
export type OrderDocumentAddressCandidate = {
  id: string;
  kind: "pickup" | "delivery" | "supplier" | "producer" | "customer" | "organization" | "port" | "crossing";
  label: string;
  address: { name: string; addressLines: string[]; phone?: string; contact?: string };
  block: string;
};

export type OrderDocumentSavedFacts = {
  carrier: string;
  freightMethod: string;
  hasBorderCrossing: boolean;
};
